import http from '@/lib/http.js';

var store = {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		init: function(store) {
			mixpanel.init('14e7b9d77962d9c0e1e7ab947adc4a49', {
				cross_site_cookie: true
			});
			var instance1 = amplitude
				.getInstance()
				.init('cea33ff894218c086d50d8ea59558f24');
			store.state.amplitudeInstance = instance1;
		},
		afterUserLogin: function(store) {
			let user = store.rootGetters['user/user'];
			amplitude.getInstance().setUserId(user._id);
			mixpanel.identify(user._id);
		},
		/**
		 *
		 * @param {*} name
		 * Pass event name or an object containing:
		 * - name (name of the event)
		 * - data (event data)
		 * @returns
		 */
		trackEvent(store, name) {
			let form = {};
			if (typeof name === 'object') {
				form.name = name.name;
				form.data = name.data || {};
			} else {
				form.name = name;
			}
			name = form.name;
			let properties = form.data || null;
			amplitude.getInstance().logEvent(name, properties);
			mixpanel.track(name, properties);
		}
	}
};

export default store;
